import { render, staticRenderFns } from "./ReporteVentaPeriodos.vue?vue&type=template&id=68b14434&scoped=true"
import script from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
export * from "./ReporteVentaPeriodos.vue?vue&type=script&lang=js"
import style0 from "./ReporteVentaPeriodos.vue?vue&type=style&index=0&id=68b14434&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b14434",
  null
  
)

export default component.exports